import React, { useContext } from "react";
import { T } from "../../../hooks/useTranslate";
import { Typography } from "@mui/material";
import { Button } from "@mui/material";
import { LanguageContext } from "../../../hooks/LanguageContext";

const GotoOldOfficeButton = ({
  styles,
  oldOfficeURL,
  handleGotoOldOffice,
  enableGotoOldOffice,
  buttonText
}) => {
  const { languageDir } = useContext(LanguageContext);
  return (
    <Button
      as="a"
      href={oldOfficeURL}
      target="backto_oldoffice_tab"
      data-test-id="goto-oldoffice-button"
      onClick={handleGotoOldOffice}
      disableRipple={!enableGotoOldOffice}
      disabled={!enableGotoOldOffice}
      sx={{
        ...styles.button,
        ...(!enableGotoOldOffice && styles.disabledButton),
        "&.Mui-disabled": {
          color: "#fff"
        }
      }}
    >
      <Typography style={styles.goNowText} variant="h4" data-test-id="goto-oldoffice-text">
        <T>{buttonText ? buttonText : "go_now_text"}</T>
      </Typography>
      <img src="icons/arrow-right.svg" alt="goto old office" style={{
        ...styles.arrow,
        transform: languageDir === "rtl" ? "rotate(180deg)" : "none"
      }} />
    </Button>
  )
}

export { GotoOldOfficeButton }